import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import NumPlateIcon from "../../../assets/images/number_plate_icon.png";
import COLORS from "../../../constants/Colors";

const NumberPlate = ({ regNo = "AB 12 CD 3456" }) => {
  return (
    <Box
      sx={{
        height: "55px",
        background: "#EAEAEA",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap", // Ensure content wraps
        overflow: "hidden", // Optional: Hide overflow content
        border: "2px solid #D9D9D9",
        boxSizing: "border-box",
        borderRadius: "4px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          height: "100%",
          width: "50px",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: COLORS.PRIMARY,
          borderRadius: "4px 0px 0px 4px",
        }}
      >
        <Box
          sx={{
            height: "25px",
            width: "25px",
            backgroundImage: `url(${NumPlateIcon})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        />
        <Typography fontSize={"0.8rem"} fontWeight={500} color="white">
          IND
        </Typography>
      </Box>
      <Typography
        fontSize={"1.2rem"}
        fontWeight={700}
        sx={{
          padding: "0 20px",
          letterSpacing: "0.25rem"
        }}
      >
        {regNo}
      </Typography>
    </Box>
  );
};

NumberPlate.propTypes = {
  regNo: PropTypes.string,
};

export default NumberPlate;
